import { render, staticRenderFns } from "./TableHeaderSettings.vue?vue&type=template&id=5545ff9e&"
import script from "./TableHeaderSettings.vue?vue&type=script&lang=js&"
export * from "./TableHeaderSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports